class MilestoneBar extends HTMLElement {
    #giftPrice = null;
    #shippingPrice = null;
    #maxPrice = null;
    #progress = null;
    #completeText = null;
    #freeShippingText = null;
    #freeGiftText = null;
    #incompleteText = null;
    #locale = null;
    #country = null;
    #currency = null; 

    constructor() {
        super();
    }
    connectedCallback() {
        this.render();
    }

    render() {
        this.#giftPrice = this.giftPrice;
        this.#shippingPrice = this.shippingPrice;
        this.#maxPrice = this.maxPrice;
        this.#locale = this.locale;
        this.#country = this.country;
        this.#currency = this.currency;
        this.#progress = this.querySelector('.gamification-inner');
        this.#completeText = this.querySelector('[data-complete]');
        this.#freeShippingText = this.querySelector('[data-free-shipping-reached]');
        this.#freeGiftText = this.querySelector('[data-free-gift-reached]');
        this.#incompleteText = this.querySelector('[data-incomplete]');

        document.addEventListener('ajaxProduct:added', (event) => {
            theme.cart.getCart().then((cart) => {
                this.update(cart);
            });
        });

        document.addEventListener('upsell:added', (event) => {
            theme.cart.getCart().then((cart) => {
                this.update(cart);
            });
        });

        document.addEventListener('cart:updated', (event) => {
            let cart = event.detail.cart;
            this.update(cart);
        });
    }

    update(cart){
        this.calculateProgress(cart);
        this.updateProgressText(cart);
    }

    calculateProgress(cart){
        this.#progress.style.width = Math.min((cart.total_price / this.#maxPrice) * 100, 100) + '%'
    }

    updateProgressText(cart){
        console.log('country: ', this.#country);

        let left_to_gift_money = Math.max(0, this.#giftPrice - cart.total_price);
        let left_to_shipping_money = Math.max(0, this.#shippingPrice - cart.total_price);

        if(this.#completeText.classList.contains('gamification-hidden') == false){
            this.#completeText.classList.add('gamification-hidden');
        }
        if(this.#freeShippingText.classList.contains('gamification-hidden') == false){
            this.#freeShippingText.classList.add('gamification-hidden');
        }
        if(this.#freeGiftText.classList.contains('gamification-hidden') == false){
            this.#freeGiftText.classList.add('gamification-hidden');
        }
        if(this.#incompleteText.classList.contains('gamification-hidden') == false){
            this.#incompleteText.classList.add('gamification-hidden');
        }

        if (left_to_gift_money == 0 && left_to_shipping_money == 0) {
            this.#completeText.classList.remove('gamification-hidden');
        } else if (left_to_shipping_money == 0 && left_to_gift_money != 0) {
            this.#freeShippingText.classList.remove('gamification-hidden');

            let formatted_left_to_gift_money  = new Intl.NumberFormat(this.#locale + '-' + this.#country, { style: 'currency', currency: this.#currency }).format(
              left_to_gift_money/100,
            )

            this.#freeShippingText.querySelector('[data-left-to-gift]').innerHTML = formatted_left_to_gift_money;
        } else if (left_to_shipping_money != 0 && left_to_gift_money == 0) {
            this.#freeGiftText.classList.remove('gamification-hidden');

            let formatted_left_to_shipping_money  = new Intl.NumberFormat(this.#locale + '-' + this.#country, { style: 'currency', currency: this.#currency }).format(
              left_to_shipping_money/100,
            )

            this.#freeGiftText.querySelector('[data-left-to-free-shipping]').innerHTML = formatted_left_to_shipping_money;
        } else {
            this.#incompleteText.classList.remove('gamification-hidden');

            let formatted_left_to_gift_money  = new Intl.NumberFormat(this.#locale + '-' + this.#country, { style: 'currency', currency: this.#currency }).format(
              left_to_gift_money/100,
            )
            let formatted_left_to_shipping_money  = new Intl.NumberFormat(this.#locale + '-' + this.#country, { style: 'currency', currency: this.#currency }).format(
              left_to_shipping_money/100,
            )

            this.#incompleteText.querySelector('[data-left-to-gift]').innerHTML = formatted_left_to_gift_money;
            this.#incompleteText.querySelector('[data-left-to-free-shipping]').innerHTML = formatted_left_to_shipping_money;
        }
    }

    get giftPrice(){
        if(this.hasAttribute("data-gift-price")){
            return this.dataset.giftPrice;
        }
    }

    get shippingPrice(){
        if(this.hasAttribute("data-shipping-price")){
            return this.dataset.shippingPrice;
        }
    }

    get maxPrice(){
        if(this.hasAttribute("data-max-price")){
            return this.dataset.maxPrice;
        }
    }

    get locale(){
        if(this.hasAttribute("data-locale")){
            return this.dataset.locale;
        }
    }

    get country(){
        if(this.hasAttribute("data-country")){
            return this.dataset.country;
        }
    }

    get currency(){
        if(this.hasAttribute("data-currency")){
            return this.dataset.currency;
        }
    }

}
customElements.define("milestone-bar", MilestoneBar);